module.exports = __webpack_public_path__ + "img/var_02_xrobot2_backlight.af2a4538.svg";